import { render, staticRenderFns } from "./AnulateMedicamentForm.vue?vue&type=template&id=3838a806"
import script from "./AnulateMedicamentForm.vue?vue&type=script&lang=js"
export * from "./AnulateMedicamentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports